import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store"; // make sure the path to your store is correct

new Vue({
  vuetify,
  router,
  store, // add this line to include your Vuex store
  render: (h) => h(App),
}).$mount("#app");
